<template>
	<div v-if="joined" class="game view">
		<Waiting v-if="waiting" />
		<div v-else class="game-grid-container">
			<GameNavBar
				:game-id="roomCode"
				@try-leave="this.$router.push('/')"
			/>
			<div class="top-bar">
				<Scoreboard :class="{ 'wait-for-animation': hideAction }" />
			</div>
			<div class="game-play">
				<div class="pop-up">
					<transition name="fade-action">
						<Winner
							class="action winner"
							v-if="winningTeam !== null"
							key="0"
						/>
						<div v-else-if="disconnectedPlayers.length > 0">
							Waiting for everyone to rejoin...
							{{ disconnectedPlayers }}
						</div>
						<guess-form
							v-else-if="game.state.turn === game.me"
							v-show="!hideAction"
							:turn="game.state.turn"
							:guess-value-prop="guessValue || ''"
							class="action guess-form"
							:key="guessFormKey"
							@pass-turn="tryPassTurn"
						/>
					</transition>
				</div>
				<div class="all-cards" v-if="cardsArray">
					<card-container
						v-for="player in game.players"
						:key="player.pos"
						:name="player.name"
						:cards="
							reverseOrder
								? cardsArray[player.pos]
								: [...cardsArray[player.pos]].reverse()
						"
						:pos="player.pos"
						:turn="game.state.turn == player.pos"
						:shown="game.me == player.pos"
						:me="game.me"
						@card-value-click="handleCardClick"
					/>
				</div>
				<div v-if="dev" class="game-info mb-40">
					<h1 class="tc-white">Game {{ gameId }}</h1>
					<secondary-button class="small" v-clipboard="copyGameLink"
						>Copy game link</secondary-button
					>
				</div>

				<LastTaken
					@display-guess-form="handleDisplayGuessForm"
					@change-guess-form-key="
						guessFormKey = (guessFormKey % 2) + 1
					"
				/>
			</div>
		</div>
		<div v-if="dev" class="dev-stuff">
			<h1>We'll be with you shortly</h1>
			<h3>Players: {{ players }}</h3>
			<h3>Me: {{ me }}</h3>
			<h3>Cards: {{ game.state.cards }}</h3>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CardContainer from "@/components/CardContainer";
import LastTaken from "@/components/LastTaken";
import GameNavBar from "@/components/GameNavBar";
import SecondaryButton from "@/components/ui/SecondaryButton";
import GuessForm from "@/components/GuessForm";
import Winner from "@/components/Winner";
import Scoreboard from "@/components/Scoreboard";
import Waiting from "@/components/Waiting";

export default {
	name: "App",
	props: ["gameId"],
	data() {
		return {
			dev: false,
			showBtns: true,
			guessValue: null,
			hideAction: false,
			guessFormKey: 2,
		};
	},
	components: {
		CardContainer,
		LastTaken,
		GameNavBar,
		SecondaryButton,
		GuessForm,
		Winner,
		Scoreboard,
		Waiting,
	},
	computed: {
		...mapGetters([
			"game",
			"cardsArray",
			"reverseOrder",
			"roomCode",
			"joined",
			"mockingServer",
			"waiting",
			"winningTeam",
			"disconnectedPlayers",
			"local",
		]),
		copyGameLink() {
			return "localhost:8080" + "/invite/" + this.gameId;
		},
		cardsOf(num) {
			const arr = [];
			for (let value in this.cardsArray) {
				for (let suit in this.cardsArray[value]) {
					if (this.cardsArray[value][suit] === num) {
						arr.push({ value, suit });
					}
				}
			}
			return arr;
		},
		displayAction() {
			if (this.hideAction) {
				return false;
			} else {
				if (this.game) {
					return (
						this.game.state.turn === this.game.me ||
						!this.game.state.inProgress
					);
				} else {
					return false;
				}
			}
		},
	},
	methods: {
		...mapActions([
			"tryPassTurn",
			"refreshState",
			"devStartGame",
			"tryLeaveGame",
		]),
		handleCardClick(aValue) {
			if (this.game.me == this.game.state.turn) {
				// console.log("Going to pass", aValue);
				this.guessValue = aValue;
			}
		},
		handleDisplayGuessForm(aBoolean) {
			this.hideAction = !aBoolean;
		},
	},
	beforeRouteLeave(to, from, next) {
		console.log("HELLOOOOOO HERE");
		if (this.joined) {
			// console.log("AM I JOINED???", this.joined);
			const answer = window.confirm(
				"Are you sure you want to leave the game?"
			);
			if (answer) {
				// console.log("WANTS TO LEAVE");
				this.tryLeaveGame();
				next();
			} else {
				next(false);
			}
		} else {
			next();
		}
	},
	created() {
		console.log(this.$route.name);
		// console.log("\n::: GAME.VUE");
		// console.log(this.local);
		// console.log("GameId prop to Game.vue", this.gameId, "\n");
		if (this.mockingServer) {
			// console.log(this.roomCode);
			// console.log("ARE THEY EQUAL?", this.gameId == this.roomCode);
			if (this.gameId == this.roomCode) {
				this.devStartGame();
			} else {
				// console.log("Reeeedirecting to Invite.vue...");
				this.$router.push({
					name: `Invite`,
					params: { gameId: this.gameId },
				});
			}
		} else {
			if (!this.joined) {
				if (this.gameId) {
					// console.log("Redirecting to Invite.vue...");
					this.$router.push({
						name: `Invite`,
						params: { gameId: this.gameId },
					});
				} else {
					// console.log("-> Redirecting to Login.vue...");
					this.$router.push({
						name: `Login`,
					});
				}
			} else {
				// console.log("THIS IS CARDS ARRAY.", this.cardsArray);
			}
		}
	},
};
</script>

<style lang="scss">
@import "../assets/scss/main.scss";

.dev-stuff {
	padding: 40px;
	font-family: "JetBrains Mono" !important;
	* {
		margin: 20pt 0;
	}
}

.top-bar {
	padding-top: 1.5em;
}

.last-taken-container {
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;

	// position: absolute;
	top: 0px;
}

.fade-action-enter-active,
.fade-action-leave-active {
	transition: all 0.6s ease-out;
}

.fade-action-enter-from,
.fade-action-leave-to {
	transform: translateY(20px);
	opacity: 0;
}

.game.view {
	padding-bottom: 40px;
	box-shadow: inset 0px 0px 160px rgba(8, 15, 19, 0.533);
	background-color: $blue-darker;
	.game-grid-container {
		position: static;
		display: flex;
		flex-direction: column;
		height: 100%;
		.game-play {
			flex-grow: 1;
			height: 100%;
			position: relative;
			.all-cards {
				// border: 8px solid green;
				padding: 20px; // Padding of the four sides
				height: 100%;
				width: 100%;
				display: grid;
				position: absolute;
				grid-template-areas:
					"top top top"
					"left action right"
					"bottom bottom bottom";
				grid-template-columns: 1fr 1fr 1fr;
				grid-template-rows: 1fr 2fr 1fr;
				// background-color: $blue-lighter;
				.card-container {
					overflow: visible;
					// outline: 1px solid red;
					&.top {
						grid-area: top;
						align-self: start;
						justify-self: center;
					}
					&.right,
					&.left {
						justify-self: center;
						align-self: center;
						margin-bottom: 12%;
					}
					&.right {
						grid-area: right;
					}
					&.bottom {
						grid-area: bottom;
						align-self: end;
						justify-self: center;
					}
					&.left {
						grid-area: left;
					}
				}
			}
			.action-container {
				grid-area: action;
				justify-self: center;
				// background-color: transparentize(cyan, 0.9);
				> .container {
					padding: 32px;
					width: 340px;
				}
			}
			.pop-up {
				position: absolute;
				top: 0;
				height: 100%;
				width: 100%;
				transition: 0.2s;

				&.dim {
					background-color: #0002;
				}

				display: flex;
				justify-content: center;
				align-items: center;
				> .action {
					background: none;
					position: absolute;
					padding-top: 0px;
					// margin-bottom: 40px;
					z-index: 2;
				}
			}
		}
	}
}
</style>
